import { useLocation } from 'react-router-dom';
import { get as _get } from 'lodash';
import { useContext } from 'react';
import { AppContext, EMPTY_STRING } from 'commons-ui';

import { GAME_KEY_MAP } from '../../utils/helper';
import useService from '../../utils/useService';

const useKeys = () => {
	const location = useLocation();
	const { app } = useContext(AppContext);
	const { getUpdateReqs } = useService();
	const { appName } = app;
	const serviceName = _get(location, 'state.keysData.serviceName', EMPTY_STRING);
	const fetchUpdateReqs = () => {
		const game = GAME_KEY_MAP[appName];
		return getUpdateReqs({ serviceName, game });
	};

	return {
		serviceName,
		fetchUpdateReqs
	};
};

export default useKeys;
